//import logo from "./logo.svg";
import { useState, useEffect } from "react";
import "antd/dist/reset.css";
import "./App.css";
import Main from "./components/main";
import { Modal, message, Button, Row, Input, Col } from "antd";

function App() {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [isResetModalVisible, setIsResetModalVisible] = useState(false);
  const [isPassword, setIsPassword] = useState("");
  const [currnetPW, setCurrentPW] = useState("");
  const [newPW, setNewPW] = useState("");
  const [confirmPW, setConfirmPW] = useState("");
  const [enteringPW, setEnteringPW] = useState("");

  const handlePassOk = () => {
    if (enteringPW !== isPassword) {
      message.error("Wrong Password!");
    } else setIsModalVisible(false);
  };
  const handleResetPassCancel = () => {
    setIsResetModalVisible(false);
  };
  function comparePws() {
    if (newPW.length === 0 || confirmPW.length === 0) {
      message.warning("Please input the new password!");
      return false;
    }
    if (newPW === confirmPW) {
      localStorage.setItem("user-content-rewriter", newPW);
      setIsPassword(newPW);
      message.success("Changed password successfully!");
      setIsResetModalVisible(false);
    } else {
      message.error("The confirm password is wrong");
    }
  }
  const handlePassReset = () => {
    if (isPassword) {
      if (currnetPW) {
        if (isPassword === currnetPW) {
          comparePws();
        } else {
          message.error("The old password is wrong");
        }
      } else {
        message.warning("Please input your old password");
      }
    } else {
      comparePws();
    }
  };

  useEffect(() => {
    const user = localStorage.getItem("user-content-rewriter");
    console.log(user);
    if (user) {
      setIsPassword(user);
    }
    else {localStorage.setItem("user-content-rewriter", 'super');
    setIsPassword('super');
  }

    return () => {};
  }, []);
  return (
    <div className="App">
      <Main />
      <Modal
        title={"Please confirm this is you"}
        visible={isModalVisible}
        onOk={handlePassOk}
        onCancel={() => {}}
        footer={[
          <Button
            key="addfund"
            type="primary"
            onClick={() => setIsResetModalVisible(true)}
          >
            Reset
          </Button>,
          <Button key="addfund" type="primary" onClick={handlePassOk}>
            OK
          </Button>,
        ]}
      >
        <Col>
          <Row>Input Your Password</Row>
          <Row style={{ padding: 10 }}>
            <Input
              autoFocus={true}
              type={"password"}
              value={enteringPW}
              onChange={(e) => {
                setEnteringPW(e.target.value);
              }}
            ></Input>
          </Row>
        </Col>
      </Modal>
      <Modal
        title={"Reset Password"}
        visible={isResetModalVisible}
        onOk={handlePassReset}
        onCancel={handleResetPassCancel}
        footer={[
          <Button key="addfund" type="primary" onClick={handlePassReset}>
            Reset
          </Button>,
        ]}
      >
        <Row align={"center"}>
          <Col span={12}>
            <Row style={{ padding: 5 }}>
              <Input
                type={"password"}
                placeholder={"Current Password"}
                value={currnetPW}
                onChange={(e) => {
                  setCurrentPW(e.target.value);
                }}
              ></Input>
            </Row>
            <Row style={{ padding: 5 }}>
              <Input
                type={"password"}
                placeholder={"New Password"}
                value={newPW}
                onChange={(e) => {
                  setNewPW(e.target.value);
                }}
              ></Input>
            </Row>
            <Row style={{ padding: 5 }}>
              <Input
                type={"password"}
                placeholder={"Confirm Password"}
                value={confirmPW}
                onChange={(e) => {
                  setConfirmPW(e.target.value);
                }}
              ></Input>
            </Row>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default App;
